'use client';

// React Imports
import { type ReactNode } from 'react';

// Third-party Imports
import { Provider } from 'react-redux';

import { PersistGate } from 'redux-persist/integration/react';

import { store } from '@/redux-store';
import { persistor } from './persistor/redux-persistor';

const ReduxProvider = ({ children }: { children: ReactNode }) => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                {children}
            </PersistGate>
        </Provider>
    );
};

export default ReduxProvider;
